import axios from 'axios';

const axiosRefresh = axios.create({
  // baseURL: "https://hackprinceton-registration-25f70f11442b.herokuapp.com",
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: 'csrf_refresh_token',
  xsrfHeaderName: 'X-CSRF-TOKEN',
});

export default axiosRefresh;
